import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
} from '@angular/core';
import type { Lyric } from '@lyricstream/shared';
import { LyricCardComponent } from '@lyricstream/shared';

/**
 * Vue "normale" de la liste de chants d'un recueil. Consomme désormais `LyricCardComponent`
 * (Frontend.Shared) — cf. design 20260823-playlist-detail-v2-suite requirement 11 :
 * LyricCardItemComponent est supprimé, il ne doit plus exister qu'une seule implémentation de
 * carte de chant dans le codebase.
 */
@Component({
  selector: 'ls-lyric-recueil-list',
  imports: [LyricCardComponent],
  templateUrl: './lyric-recueil-list.component.html',
  styleUrl: './lyric-recueil-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LyricRecueilListComponent {
  readonly items = input.required<Lyric[]>();
  readonly view = input<'grid' | 'list'>('list');
  readonly showNo = input<boolean>(true);
  readonly numbered = input<boolean>(false);
  readonly loading = input<boolean>(false);
  readonly allLoaded = input<boolean>(false);
  readonly lang = input<string>('fr');

  readonly showContributor = input<boolean>(true);

  protected lyricHref(lyric: Lyric): string {
    return `/${this.lang()}/lyric/${lyric.slug}`;
  }
}
